<template>
  <div>


    <div class="d-flex flex-column" style="flex: 1 1 100%">
      <div class="d-flex align-center justify-space-around" style="" v-for="(item, index) in form" :key="index">
        <v-text-field :label="$t('mainStore.aboutStore.SL.label')" class="mr-4" style="flex: 0 0 40%" v-model="item.text"
          :rules="[
            fieldRules.compare(item.text, form)
          ]" type="text" /><!-- fieldRules.compare(item.text)-->
        <v-text-field style="flex: 0 0 40%" min="0" step="1" max="100" class="ml-6 mr-4" :rules="[

          fieldRules.percentCompare(total),

        ]" type="number" v-model="item.value" suffix="%"></v-text-field><!--   fieldRules.required(item.text), -->
        <v-btn icon @click="removeAudienceField(index)" color="red" class="ml-4 ">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>

      </div>
    </div>
    <div class="d-flex justify-end">
      <v-btn icon @click="add" color="green" large>
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
    </div>
    <!-- <v-icon :disabled="disabledCheck" @click="save" class="ml-4 green--text"
      >mdi-check-circle-outline</v-icon
    > -->

  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AudienceSocialClass",

  data() {
    return {
      disabledCheck: true,
      fieldRules: {

        compare(value, list) {
          if (value == null) return true
          return (list.filter(item => (item.text.includes(value) && item.text != '') || (value.includes(item.text) && item.text != ''))).length > 1 ? 'A classe social não pode se repetir' : true
        },
        percentCompare(value) {
          return value != 100 ? `A somoa dos percentuais dos grupos deve completar  100% (A soma é ${value}%)` : true
        },
      },

      form: [

      ],
      item: {
        primaryAge: null,
        secondAge: null,
        value: null,
      },
    };
  },
  props: {
    snap: Array
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.save()
      }
    },
    'selectedStore': {
      deep: true,
      haldler() {
        this.form = this.snap
      }
    },
  },
  mounted() {
    this.form = this.snap
  },


  computed: {
    ...mapState("groupStores", [
      "selectedStore",
    ]),
    total() {
      let sum = 0
      const result = this.form.reduce((total, current) => total + (isNaN(parseFloat(current.value)) ? 0 : (parseFloat(current.value))), sum)
      return result
    },

  },

  methods: {
    minFirst(value, index) {
      if (index == 0) {
        return 0
      }
      else {
        return parseFloat(this.form[index - 1].secondAge) + 1
      }
    },
    min(value) {
      return parseFloat(value) + 1
    },
    save() {
      this.$emit('update-store', this.form)
    },

    add() {
      let objItem = {
        text: "",
        value: null
      };
      this.form.push(objItem);
      this.disabledCheck = false
    },
    removeAudienceField(index) {

      this.form.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped></style>
